var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.activeDrawer,_vm._g(_vm._b({tag:"component"},'component',_vm.drawerProps,false),_vm.drawerListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }